import { useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const CBSEResult = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    { label: "School Profile ", link: "/schoolprofile" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },
    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  const [filterData, setFilterData] = useState("0");
  const filterYear = (value) => {
    setFilterData(value);
  };
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/staff.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="CBSE Results"
                breadEnd="CBSE Results"
                breadMid="Admissions"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="selection_list float-end mb-4">
                <select
                  onChange={(e) => filterYear(e.target.value)}
                  className="p-2"
                >
                  <option value="0">Year 2025-2026</option>
                  <option value="6">Year 2024-2025</option>
                  <option value="1">Year 2023-2024</option>
                  <option value="2">Year 2022-2023</option>
                  <option value="3">Year 2021-2022</option>
                  <option value="4">Year 2020-2021</option>
                  <option value="5">Year 2019-2020</option>
                </select>
              </div>

              {filterData === "0" && (
                <div className="">
                  <h4 className="page-title color-red"> Class X </h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-1.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-2.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-3.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-4.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-5.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-6.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-7.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  {/* <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-25-8.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad> */}
                  <h4 className="page-title color-red"> Class XII </h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-1.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-2.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-3.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-4.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-5.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-6.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                </div>
              )}

              {filterData === "6" && (
                <div className="">
                  <h4 className="page-title color-red"> Class X</h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-1.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-2.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-3.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-4.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-5.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-6.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-7.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-8.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-9.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <h4 className="page-title color-red mt-4"> Class XII</h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-10.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-11.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-12.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-13.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-14.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-15.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-16.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-17.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-24-18.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                </div>
              )}
              {filterData === "1" && (
                <div className="">
                  <h4 className="color-red"> Class X</h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-1.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-2.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-3.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-4.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-5.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-6.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-7.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-8.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-9.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <h4 className="color-red"> Class XII</h4>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-10.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-11.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-12.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-13.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-14.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-15.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-16.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-17.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-18.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-23-19.webp"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                </div>
              )}
              {filterData === "2" && (
                <div className="">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-1.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-2.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-3.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-4.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-5.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-6.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-7.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-8.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-9.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-10.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-11.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-12.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-13.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-14.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cbse-22-15.jpg"
                      className="img-fluid wid-100"
                      alt="Lotus Valley School, Gurgaon"
                    />
                  </LazyLoad>
                </div>
              )}
              {filterData === "3" && (
                <div className="">
                  <div class="table">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/heartiest.webp"
                        width="100%"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="heading2 text-center">
                    <h4>25 Students fall in the bracket of</h4>
                    <h4 className="color-red">100 MARK CLUB</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th> SUBJECT </th>
                          <th> MARKS </th>
                          <th> LEARNER’S NAME </th>
                        </tr>
                        <tr>
                          <td>MATHEMATICS (Standard)</td>
                          <td>100 (3 Learners)</td>
                          <td>Shaurya Agarwal, Saanvi Das, Navya Nandini</td>
                        </tr>
                        <tr>
                          <td>ENGLISH</td>
                          <td> 100 (3 Learners)</td>
                          <td> Tejal Doshi, Saanvi Das, Ramdas Singh</td>
                        </tr>
                        <tr>
                          <td> FRENCH</td>
                          <td> 100 (1 Learner)</td>
                          <td> Priyadarshini Ghosh</td>
                        </tr>
                        <tr>
                          <td> GERMAN</td>
                          <td> 100 (2 Learners)</td>
                          <td> Lakshya Agarwal, Yash Verma </td>
                        </tr>
                        <tr>
                          <td> SOCIAL SCIENCE</td>
                          <td> 100 (2 Learner)</td>
                          <td> Aviraj Goyle, Mannan Rana</td>
                        </tr>
                        <tr>
                          <td>SANSKRIT</td>
                          <td> 100 (1 Learner)</td>
                          <td> Raghav Bansal</td>
                        </tr>
                        <tr>
                          <td>ARTIFICIAL INTELLIGENCE</td>
                          <td> 100 (13 Learners)</td>
                          <td>
                            {" "}
                            Priyadarshini Ghosh,Tejal Doshi, Raghav Bansal,
                            Navya Nandini Dhody, Garv Agarwal, Chaitanya Gupta,
                            Vinyak Malhotra, Soumyavardhan Maheshwari, Kshitij
                            Verma, Deepti Khetan, Anushka Jain, Tanishka Sharma,
                            Arya Setia{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>SUBJECT</th>
                          <th>MARKS</th>
                          <th>LEARNER’S NAME</th>
                        </tr>
                        <tr>
                          <td>SCIENCE </td>
                          <td>99(9 learner) </td>
                          <td>
                            Amulyaa Kashyap, Garv Agarwal, Arav Mathur, Mannan
                            Rana, Aarzoo Kapoor, Kshitij Verma, Tamana Kapoor,
                            Vinayak Malhotra, Parth Ahuja
                          </td>
                        </tr>
                        <tr>
                          <td>PAINTING </td>
                          <td>98(1 learners) </td>
                          <td>Vanini Yagnik</td>
                        </tr>
                        <tr>
                          <td>HINDI</td>
                          <td>97(5 learner)</td>
                          <td>
                            Saanvi Das, Arav Mathur, Anya Goyal, Aadya Jain,
                            Jiya Mahajan
                          </td>
                        </tr>
                        <tr>
                          <td>MATHEMATICS (Basic)</td>
                          <td>96(1 learner) </td>
                          <td>Kaina Malik</td>
                        </tr>
                        <tr>
                          <td>SPANISH</td>
                          <td>84(1 learner) </td>
                          <td>Gaurika Khanna</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table">
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/heartiest-avg.webp"
                        width="100%"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="text-box gallery-sec mb-4">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/INHAAS-VIRMANI.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>INHAAS VIRMANI </p>
                          <p>(Science Stream Topper) 97.8% </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/ANANYA-JAIN.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ANANYA JAIN</p>
                          <p>(Science Stream) 97.6%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/roli-aggrwal.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ROLI AGGARWAL</p>
                          <p>(Commerce Stream Topper) 97.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/shivika-pandey.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>SHIVIKA PANDEY</p>
                          <p>(Humanities Stream Topper) 97.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/yashita-agarwal.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>YASHITA AGARWAL</p>
                          <p>(Commerce Stream) 96.8%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/SAAGARIKA-GAHLOT.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>SAAGARIKA GAHLOT</p>
                          <p>(Commerce Stream) 96.4%</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="heading2 text-center">
                    <h4>14 Students fall in the bracket of</h4>
                    <h4 className="color-red">100 MARK CLUB</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>SUBJECT</th>
                          <th>MARKS</th>
                          <th>LEARNER'S NAME</th>
                        </tr>
                        <tr>
                          <td> BUSINESS STUDIES</td>
                          <td> 100 (5 Learners) </td>
                          <td>
                            {" "}
                            Saagarika Gahlot , Sarmatha R, Arushi Banerjee,
                            Gayatri Varma, Anirudh Rathod{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PSYCHOLOGY</td>
                          <td> 100 (4 Learners) </td>
                          <td>
                            {" "}
                            Asvika Nigam , Shivika Pandey , Vikramaditya Yadav,
                            Tanvi Chand{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> COMPUTER SCIENCE </td>
                          <td> 100 (2 Learners) </td>
                          <td> Inhaas Virmani , Arunaksh Kapoor </td>
                        </tr>
                        <tr>
                          <td> MATHEMATICS </td>
                          <td> 100 (2 Learners) </td>
                          <td> Inhaas Virmani , Siddharth Mishra </td>
                        </tr>
                        <tr>
                          <td> ECONOMICS </td>
                          <td> 100 (1 Learner) </td>
                          <td> Roli Aggarwal </td>
                        </tr>
                        <tr>
                          <td> ACCOUNTANCY </td>
                          <td> 100 (1 Learner) </td>
                          <td> Sarmatha R </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>SUBJECT</th>
                          <th>MARKS</th>
                          <th>LEARNER'S NAME</th>
                        </tr>
                        <tr>
                          <td> BIOLOGY </td>
                          <td> 99 </td>
                          <td> Aradhya Mishra Vikramaditya Yadav </td>
                        </tr>
                        <tr>
                          <td> POLITICAL SCIENCE </td>
                          <td> 99 </td>
                          <td> Shivika Pandey </td>
                        </tr>
                        <tr>
                          <td> HISTORY </td>
                          <td> 99 </td>
                          <td> Akshita Sharma </td>
                        </tr>
                        <tr>
                          <td> LEGAL STUDIES </td>
                          <td> 99 </td>
                          <td> Rashi Chauhan </td>
                        </tr>
                        <tr>
                          <td> CHEMISTRY </td>
                          <td> 98 </td>
                          <td> Ananya Jain </td>
                        </tr>
                        <tr>
                          <td> PAINTING </td>
                          <td> 98 </td>
                          <td> Maanyaa Gupta </td>
                        </tr>
                        <tr>
                          <td> ENGLISH </td>
                          <td> 97 </td>
                          <td> Adrija De </td>
                        </tr>
                        <tr>
                          <td> PHYSICS </td>
                          <td> 97 </td>
                          <td> Inhaas Virmani , Nipun Yadav </td>
                        </tr>
                        <tr>
                          <td> PHYSICAL EDUCATION </td>
                          <td> 97 </td>
                          <td>
                            {" "}
                            Arunaksh Kapoor , Khyati Prasad , Vidit Yaduvanshi,
                            Lord Lugani, Megha Bisht{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> APPLIED MATHEMATICS </td>
                          <td>95 </td>
                          <td> Saagarika Gahlot </td>
                        </tr>
                        <tr>
                          <td> INFORMATICS PRACTICES </td>
                          <td> 94 </td>
                          <td> Palak Kabra </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {filterData === "4" && (
                <div className="">
                  <div class="table mb-4">
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/aisse-results.webp"
                        width="100%"
                        alt="Lotus Valley School, Gurgaon"
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </div>
                  <div class="heading2 text-center mb-4">
                    <h4>LEARNERS EXCEL IN AISSE 2020-21</h4>
                    <h4 className="color-red">THE TOP 5</h4>
                  </div>
                  <div class="text-box gallery-sec mb-4">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/preksha-bhora.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>PREKSHA BOHRA </p>
                          <p>99.8% </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/dhruv-mehta.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>DHRUV MEHTA</p>
                          <p>99.8% </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/anushka-rathore.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ANUSHKA RATHORE </p>
                          <p>99.8% </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/ahan-daidipya-kanrhre.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>AHAAN DAIDIPYA KANHERE </p>
                          <p>99.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/rohini-verma.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ROHINI VERMA</p>
                          <p>99.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/ananya-prakash.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ANANYA PRAKASH </p>
                          <p>98.6%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/krishang-ashwini-kumar.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>KRISHANG ASHWINI KUMAR</p>
                          <p>98.4 %</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/arnav-pratap-singh.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ARNAV PRATAP </p>
                          <p>98.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/aadya-mukherjee.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>AADYA MUKHERJEE</p>
                          <p>98.4%</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/bhakti-bansal.webp"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>BHAKTI BANSAL</p>
                          <p>98.4 %</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS</h4>
                    <h4 className="color-red">100 MARKS CLUB</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th> SUBJECT </th>
                          <th> MARKS </th>
                          <th> LEARNER'S NAME </th>
                        </tr>
                        <tr>
                          <td>MATHEMATICS(Standard)</td>
                          <td>100 (19 Learners)</td>
                          <td>
                            Agrim Gupta, Aayush Amit Bhimani,Akshat Pundhir,
                            Anushka Rathore,Dhruv Mehta, Krishang Ashwini K,
                            Aadya Gupta, Suchit Srivastava, Abhigyan Srivastava,
                            Bhakti Bansal, Parth Yadav,Rishita Singh, Royce
                            Kapoor,Aadya Mukherjee,Ahaan Daidipya Kanhere
                            ,Bhavya Jain,Preksha Bohra, Rayna Maheshwari, Suhani
                            Deepak Agrawat
                          </td>
                        </tr>
                        <tr>
                          <td>MATHEMATICS(Basic)</td>
                          <td> 100 (1 Learner)</td>
                          <td> Rohini Verma</td>
                        </tr>
                        <tr>
                          <td> ENGLISH</td>
                          <td> 100(14 Learners)</td>
                          <td>
                            {" "}
                            Krisha Rastogi, Ananya Prakash , Anushka Rathore ,
                            Dhruv Mehta , Ishita Bhushan, Aryan Kapoor, Debanshu
                            Nayak, Shreya Majumdar, Suchit Srivastava, Aadya
                            Mukherjee, Ahaan Daidipya Kanhere,Preksha
                            Bohra,Cheryl Joshi, Miheeka Bhasin
                          </td>
                        </tr>
                        <tr>
                          <td> FRENCH</td>
                          <td> 100 (3 Learners)</td>
                          <td> Bhakti Bansal, Miheeka Bhasin, Rohini Verma</td>
                        </tr>
                        <tr>
                          <td> SPANISH</td>
                          <td> 100 (1 Learner)</td>
                          <td> Preksha Bohra</td>
                        </tr>
                        <tr>
                          <td>SCIENCE</td>
                          <td> 100 (1 Learner)</td>
                          <td> Dhruv Mehta</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th> SUBJECT </th>
                          <th> MARKS </th>
                          <th> LEARNER'S NAME </th>
                        </tr>
                        <tr>
                          <td>ARTIFICIAL INTELLIGENCE</td>
                          <td>100 (22 Learners)</td>
                          <td>
                            Vidyaansh Kohli, Ananya Prakash, Anushka Rathore,
                            Dhruv Mehta, Muskan Dahiya, Pratham Chawla, Prisha
                            Dalal, Tarush Chaudhary, Ananyaa Subramanian, Bhakti
                            Bansal, Gaurika Singh, Pratham Lal, Preethi Kannan,
                            Prisha Sood, Aadya Mukherjee, Aditya Gosain, Ahaan
                            Daidipya Kanhere,Manya Malik, Preksha Bohra, Rayna
                            Maheshwari, Miheeka Bhasin, Rohini Verma
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>SUBJECT</th>
                          <th>MARKS</th>
                          <th>LEARNER'S NAME</th>
                        </tr>
                        <tr>
                          <td>HINDI</td>
                          <td>99(1 learner)</td>
                          <td>Bhavya Jain</td>
                        </tr>
                        <tr>
                          <td>SOCIAL SCIENCE</td>
                          <td>99(2 learners)</td>
                          <td>Dhruv Mehta, Ahaan Daidipya Kanhere</td>
                        </tr>
                        <tr>
                          <td>SANSKRIT</td>
                          <td>97(1 learner)</td>
                          <td>Suhani Deepak Agrawat</td>
                        </tr>
                        <tr>
                          <td>COMPUTER APPL.</td>
                          <td>97(1 learner)</td>
                          <td>Manas Kumaria</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS</h4>
                  </div>
                  <div class="table">
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/aisse-avgs.webp"
                        alt="Lotus Valley School, Gurgaon"
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </div>
                </div>
              )}
              {filterData === "5" && (
                <div className="">
                  <div class="table">
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/results-19-20.webp"
                        width="100%"
                        alt="Lotus Valley School, Gurgaon"
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/results-1920.webp"
                        width="100%"
                        alt="Lotus Valley School, Gurgaon"
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </div>
                  <div class="heading2  text-center">
                    <h4>SUBJECT TOPPERS </h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th> SUBJECT </th>
                          <th> HIGHEST SCORE </th>
                          <th> NAME </th>
                        </tr>
                        <tr>
                          <td> ENGLISH</td>
                          <td> 98</td>
                          <td> SONALI GOEL,ANVI GARG, KHUSHI ANAND</td>
                        </tr>
                        <tr>
                          <td> PHYSICS</td>
                          <td> 96</td>
                          <td> TANISH AGARWAL</td>
                        </tr>
                        <tr>
                          <td> ACCOUNTANCY</td>
                          <td> 96</td>
                          <td>ANKUSH DHAWAN </td>
                        </tr>
                        <tr>
                          <td> POLITICAL SC.</td>
                          <td>95 </td>
                          <td>
                            {" "}
                            AKSHITA MAKIN,KHUSHI ANAND, PRANAV GOSWAMY,PRERNA
                            VIJ
                          </td>
                        </tr>
                        <tr>
                          <td>CHEMESTRY </td>
                          <td> 99</td>
                          <td> PRIKSHIT </td>
                        </tr>
                        <tr>
                          <td>BUSINESS STUDIES </td>
                          <td>98 </td>
                          <td>ANVI GARG </td>
                        </tr>
                        <tr>
                          <td> HISTORY</td>
                          <td> 94</td>
                          <td>KHUSHI ANAND </td>
                        </tr>
                        <tr>
                          <td>MATHS</td>
                          <td>99</td>
                          <td>
                            KRITI SINGHAL,SONALI GOEL, TANISH AGARWAL, AMEYA
                            ASHISH DEHADE,ANIKET SINGH
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>SUBJECT TOPPERS </h4>
                  </div>
                  <div class="table">
                    <table border="1" width="100%">
                      <tbody>
                        <tr>
                          <th> SUBJECT </th>
                          <th> HIGHEST SCORE </th>
                          <th> NAME </th>
                        </tr>
                        <tr>
                          <td>PSYCHOLOGY</td>
                          <td>99</td>
                          <td>ANANDI RAY</td>
                        </tr>
                        <tr>
                          <td>LEGAL STUDIES</td>
                          <td>99</td>
                          <td>SUKHMANI SINGH</td>
                        </tr>
                        <tr>
                          <td>BIOLOGY</td>
                          <td>99</td>
                          <td>PRIYA BASIL</td>
                        </tr>
                        <tr>
                          <td>COMPUTER SC.</td>
                          <td>98</td>
                          <td>TANISH AGARWAL</td>
                        </tr>
                        <tr>
                          <td>ECONOMICS</td>
                          <td>96</td>
                          <td>
                            ANUSHKA KHURANA, ANVI GARG, MUSKAN VASAL, SANCHIT
                            GUGLANI
                          </td>
                        </tr>
                        <tr>
                          <td>INFORMATICS PRACTICES</td>
                          <td>97</td>
                          <td>
                            AMEYA ASHISH DEHADE, ANIKET SINGH, PRANAV GOSWAMY
                          </td>
                        </tr>
                        <tr>
                          <td>PE</td>
                          <td>98</td>
                          <td>PRIKSHIT, PRANAV GOSWAMY</td>
                        </tr>
                        <tr>
                          <td>PAINTING</td>
                          <td>99</td>
                          <td>TANYA SINGH, D.ALOKA</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default CBSEResult;
